import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_snap_link = _resolveComponent("snap-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.available, (transport) => {
      return (_openBlock(), _createBlock(_component_snap_link, {
        class: "mb-2 block",
        key: transport,
        onClick: ($event: any) => (_ctx.$emit('select', transport))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Send New Code By " + _toDisplayString(_ctx.METHODS_LABELS[transport as TransportEnum]), 1)
        ]),
        _: 2
      }, 1032, ["onClick"]))
    }), 128))
  ]))
}